@if (mailSent$ | async) {
  <cx-spinner class="overlay"></cx-spinner>
}
<div class="cx-modal-container">
  <div class="cx-modal-content">
    <!-- Modal Header -->
    <div aria-live="polite" aria-atomic="true" class="cx-dialog-header modal-header">
      <div id="dialogTitle" class="cx-dialog-title modal-title">
        {{
        'orderDetails.resendEmail' | cxTranslate
        }}
      </div>
      <button type="button" class="close" attr.aria-label="{{ 'addToCart.closeModal' | cxTranslate }}"
        (click)="dismissModal('Cross click')">
        <span aria-hidden="true">
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </span>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="cx-modal-body">
      <form [formGroup]="emailGroup" (submit)="sendEmail()" >
        <!-- Existing Email -->
        <div class="col-12 col-md-6">
          <mat-form-field class="resend-email">
            <mat-label>{{ 'orderDetails.email' | cxTranslate }}</mat-label>
            <input matInput type="email" class="resend-email-input"
              (blur)="updateErrorMessage()"
              formControlName="existingEmailID" />
          </mat-form-field>
        </div>
        <!-- New Email -->
        <div class="col-12 col-md-6">
          <mat-form-field  appearance="outline" class="resend-email">
            <mat-label>{{ 'orderDetails.emailConfirmation' | cxTranslate }}</mat-label>
            <input matInput type="email" formControlName="resendEmailID"  class="resend-email-input" />
          </mat-form-field>
          @if (emailGroup.invalid) {
            <mat-error>{{errorMessage()}}</mat-error>
          }
        </div>
        <div class="d-flex flex-row justify-content-end">
          <button class="btn btn-primary" type="submit" [disabled]="!emailGroup.valid">
            {{'orderDetails.resendEmailAgain' | cxTranslate}}
          </button>
        </div>
      </form>
      <mat-divider></mat-divider>
    </div>
  </div>
</div>